import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // Correct import for jwt-decode

const PrivateRoute = ({ element }) => {
  const [isValidToken, setIsValidToken] = useState(null);

  useEffect(() => {
    const authToken = localStorage.getItem("token");

    if (!authToken) {
      setIsValidToken(false);
      return;
    }

    try {
      // Decode the token to check its validity
      const decodedToken = jwtDecode(authToken);

      // Check if the token has expired
      const isTokenExpired = decodedToken.exp * 1000 < Date.now();

      if (isTokenExpired) {
        localStorage.removeItem("token"); // Clear invalid token
        setIsValidToken(false);
      } else {
        setIsValidToken(true);
      }
    } catch (error) {
      console.error("Invalid token:", error.message);
      localStorage.removeItem("token"); // Clear malformed token
      setIsValidToken(false);
    }
  }, []);

  // Render a loading spinner while checking the token validity
  if (isValidToken === null) {
    return <div>Loading...</div>;
  }

  // Navigate to login if token is invalid, otherwise render the protected element
  return isValidToken ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
